import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Collapse } from 'reactstrap';

const getInitialState = (storageKey, defaultOpen) => {
  if (!storageKey || typeof window === 'undefined') {
    return defaultOpen;
  }

  const storedValue = window.localStorage.getItem(storageKey);
  if (storedValue === null) {
    return defaultOpen;
  }

  return storedValue === '1';
};

const CollapsibleFilterSection = ({
  title = 'Filtrlar',
  summary = '',
  actions = null,
  children,
  defaultOpen = true,
  storageKey = '',
  className = '',
  contentClassName = ''
}) => {
  const [isOpen, setIsOpen] = useState(() => getInitialState(storageKey, defaultOpen));

  useEffect(() => {
    if (!storageKey || typeof window === 'undefined') {
      return;
    }

    window.localStorage.setItem(storageKey, isOpen ? '1' : '0');
  }, [isOpen, storageKey]);

  return (
    <div className={`med-filter-collapse${isOpen ? ' is-open' : ' is-collapsed'}${className ? ` ${className}` : ''}`}>
      <div className="med-filter-collapse-head">
        <div className="med-filter-collapse-copy">
          <div className="med-filter-collapse-kicker">
            <FontAwesomeIcon icon="filter" />
            <span>{title}</span>
          </div>
          {summary ? <div className="med-filter-collapse-summary">{summary}</div> : null}
        </div>
        <div className="med-filter-collapse-actions">
          {actions}
          <Button
            type="button"
            color="light"
            size="sm"
            className="med-filter-collapse-toggle"
            onClick={() => setIsOpen(open => !open)}
          >
            <FontAwesomeIcon icon={isOpen ? 'chevron-up' : 'chevron-down'} className="mr-2" />
            {isOpen ? "Yig'ish" : 'Ochish'}
          </Button>
        </div>
      </div>

      <Collapse isOpen={isOpen}>
        <div className={`med-filter-collapse-body${contentClassName ? ` ${contentClassName}` : ''}`}>{children}</div>
      </Collapse>
    </div>
  );
};

export default CollapsibleFilterSection;
